/**
 * W97 — Die EINE Ampel-Sprache (V6-Audit Agent 1, Konsistenz P1).
 *
 * Vorher drei Dialekte: Emojis 🟢🟠🔴, Lucide-Icons, CSS-Dots. Diese
 * Komponente ist der gemeinsame Punkt; Emojis bleiben nur als
 * Markenzeichen des Chart-Checks erlaubt.
 */
import { cn } from '@/lib/utils';

export type StatusDotTone = 'green' | 'yellow' | 'red' | 'gray';

const DOT_CLASS: Record<StatusDotTone, string> = {
  green: 'bg-emerald-400',
  yellow: 'bg-amber-400',
  red: 'bg-red-400',
  gray: 'bg-zinc-600',
};

/** Dezenter Glow, damit die Farbe auch bei 8px Größe sofort lesbar ist. */
const GLOW_CLASS: Record<StatusDotTone, string> = {
  green: 'shadow-[0_0_6px_rgba(52,211,153,0.6)]',
  yellow: 'shadow-[0_0_6px_rgba(251,191,36,0.6)]',
  red: 'shadow-[0_0_6px_rgba(248,113,113,0.6)]',
  gray: '',
};

export function StatusDot({
  tone,
  className,
  size = 'md',
}: {
  tone: StatusDotTone;
  className?: string;
  size?: 'sm' | 'md';
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-block rounded-full shrink-0',
        size === 'sm' ? 'size-1.5' : 'size-2',
        DOT_CLASS[tone],
        GLOW_CLASS[tone],
        className
      )}
    />
  );
}
